module.exports = __webpack_public_path__ + "img/meet_logo.d47a6db8.png";